import { render } from "./CollapseableMenu.vue?vue&type=template&id=396cf526&scoped=true"
import script from "./CollapseableMenu.vue?vue&type=script&lang=js"
export * from "./CollapseableMenu.vue?vue&type=script&lang=js"

import "./CollapseableMenu.vue?vue&type=style&index=0&id=396cf526&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396cf526"]])

export default __exports__